import React, { useEffect, useState, useRef } from 'react';
export function MasterJoeSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section className="py-16 px-4 bg-white" data-id="element-272">
      <div className="max-w-4xl mx-auto text-center" data-id="element-273">
        <div ref={sectionRef} className={`space-y-6 transition-all duration-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'}`} data-id="element-274">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0f1f3d] mb-2" data-id="element-275">
            Master Joe Whitworth
          </h2>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-4" data-id="element-276"></div>
          <p className="text-xl text-gray-600 font-medium" data-id="element-277">
            Founder & Head Instructor
          </p>

          <div className="relative w-48 h-48 sm:w-64 sm:h-64 mx-auto rounded-full overflow-hidden border-4 border-[#a3d977]/30 shadow-xl mt-8" data-id="element-278">
            <img src="https://cdn.magicpatterns.com/uploads/9VqJBAVuKuzEQMSbmyj7Ln/AboutMasterJoe.jpg" alt="Master Joe Whitworth" className="w-full h-full object-cover" data-id="element-279" />
          </div>
        </div>
      </div>
    </section>;
}